import React from "react";

function Criminal() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Criminal</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              This area involves either defending or prosecuting people. It is all a matter of applying the law to the facts and the evidence.
              </p>
              <p>
              Whether it involves going with a client to place a complaint with a local Police Station or filing a complaint with the Public Prosecution, we have been through it.  We have also been involved in cases where we have had to defend people for various matters.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Criminal;
